import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgHome extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg viewBox="0 0 300 265.28" height={size}>
                <g>
                    <path
                        d="M297.37,155.41,231.3,92.05,155.87,19.72a8.49,8.49,0,0,0-11.75,0L68.7,92.05,2.63,155.41A8.49,8.49,0,0,0,8.5,170H36.4V274.16a8.49,8.49,0,0,0,8.49,8.49h76.23V221h57.75v61.66h76.23a8.49,8.49,0,0,0,8.49-8.49V170h27.9A8.49,8.49,0,0,0,297.37,155.41Z"
                        transform="translate(0 -17.36)"
                        fill={color}
                    />
                </g>
            </svg>
        );
    }
}

export default withTheme(SvgHome);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgHome.js